import { MasterCampaignPlanCampaignBuilderType } from '../api/interfaces/MasterCampaignStub'

export enum CampaignType {
  Internet = 'Internet',
  TV = 'TV',
  Billboard = 'Billboard',
  Audio = 'Audio'
}

export const getCampaignTypeNameShort = (type: CampaignType | MasterCampaignPlanCampaignBuilderType | string): string => {
  switch (type) {
    case CampaignType.Internet:
    case MasterCampaignPlanCampaignBuilderType.Internet:
    case 'Internet':
      return 'Internet'
    case CampaignType.TV:
    case MasterCampaignPlanCampaignBuilderType.TV:
    case 'TV':
      return 'CTV'
    case CampaignType.Billboard:
    case MasterCampaignPlanCampaignBuilderType.Billboard:
    case 'Billboard':
      return 'Digital Billboard'
    case CampaignType.Audio:
    case MasterCampaignPlanCampaignBuilderType.Audio:
    case 'Audio':
      return 'Streaming Audio'
    case MasterCampaignPlanCampaignBuilderType.OffAdCritter:
    case 'OffAdCritter':
      return 'Off AdCritter'
    default:
      return ''
  }
}

export const getCampaignTypeNameLong = (type: CampaignType | MasterCampaignPlanCampaignBuilderType | string): string => {
  switch (type) {
    case CampaignType.Internet:
    case MasterCampaignPlanCampaignBuilderType.Internet:
    case 'Internet':
      return 'Internet Display'
    case CampaignType.TV:
    case MasterCampaignPlanCampaignBuilderType.TV:
    case 'TV':
      return 'Connected TV (CTV)'
    case CampaignType.Billboard:
    case MasterCampaignPlanCampaignBuilderType.Billboard:
    case 'Billboard':
      return 'Digital Billboard'
    case CampaignType.Audio:
    case MasterCampaignPlanCampaignBuilderType.Audio:
    case 'Audio':
      return 'Streaming Audio'
    case MasterCampaignPlanCampaignBuilderType.OffAdCritter:
    case 'OffAdCritter':
      return 'Off AdCritter'
    default:
      return ''
  }
}
